import { useMutation } from '@tanstack/react-query';
import { useModulesStore } from '@wkda/funnel-components';
export function useCreateCarlead() {
  const {
    carleadModule: {
      createCarlead
    }
  } = useModulesStore();
  return useMutation({
    mutationKey: ['createConsumerCarlead'],
    mutationFn: payload => createCarlead(payload)
  });
}